import React, { useMemo } from 'react'
import Loading from 'react-lottie'
import { withStyles } from '@material-ui/core/styles'
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@material-ui/core'
import { colors } from '../../../Themes'
import { empty, UpdateManual } from '../../../Themes/Images'
import { Text } from '../..'
import moment from 'moment'
import { tableCellStyles, tableRowStyles, useStylesTable } from './PaymentTable.styles'
import { SkeletonTableForFile } from '../../SkeletonTable/SkeletonTable'
import updatedReportName from '../../../Utils/uppercaseFIrstLetter'

const EMPTY = {
  loop: true,
  autoplay: true,
  animationData: empty,
  rendererSettings: {
    className: 'loading',
  },
}

const StyledTableCell = withStyles((theme) => (tableCellStyles))(TableCell)

const StyledTableRow = withStyles((theme) => (tableRowStyles))(TableRow)

export default function PaymentTableFiles({ 
  files,
  loading, 
  rowsPerPage, 
  page, 
  handleChangePage, 
  handleChangeRowsPerPage, 
  rowsPerPageOptions, 
  btnProps,
  nextIconButtonProps,
  error,
  editRow
}) {
  const classes = useStylesTable()

  const sortedFiles = useMemo(() => files?.sort(((a, b) => {
    return new Date(b.uploadDate) - new Date(a.uploadDate)
  })), [files])

  if (loading) {
    return (
      <SkeletonTableForFile />
    )
  }

  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table className={classes.table} aria-label="customized table">
        <TableHead>
          <TableRow className={classes.tableFont}>
            <StyledTableCell><Text size='footnote' weight='bold'>File Name</Text></StyledTableCell>
            <StyledTableCell align="left"><Text size='footnote' weight='bold'>Template Name</Text></StyledTableCell>
            <StyledTableCell align="left"><Text size='footnote' weight='bold'>Upload Date</Text></StyledTableCell>
            <StyledTableCell align="left"><Text size='footnote' weight='bold'>Last Update</Text></StyledTableCell>
            <StyledTableCell align="left"><Text size='footnote' weight='bold'>Type</Text></StyledTableCell>
            <StyledTableCell align="center"><Text size='footnote' weight='bold'>Status</Text></StyledTableCell>
            <StyledTableCell align="left"><Text size='footnote' weight='bold'>Actions</Text></StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedFiles?.length > 0 && sortedFiles?.map((file) =>
            (
              <StyledTableRow key={file?.id}>
                <StyledTableCell>
                  <Text 
                    size='footnote' 
                    weight="normal" 
                    color={colors.primary} 
                  >  
                    {file?.fileName}
                  </Text>
                </StyledTableCell>
                <StyledTableCell>
                  <Text 
                    size='footnote' 
                    weight="normal" 
                    color={colors.primary} 
                  >  
                    {updatedReportName(file?.reportName)}
                  </Text>
                </StyledTableCell>
                <StyledTableCell align="left" component="th" scope="row">
                  <Text size='footnote'>{file?.uploadDate}</Text>
                </StyledTableCell>
                <StyledTableCell align="left" component="th" scope="row">
                  <Text size='footnote'>{moment(file?.updatedAt).format('LLL')}</Text>
                </StyledTableCell>
                <StyledTableCell align="left" style={{ width: 70 }}>
                  <Text 
                    size='footnote' 
                    weight="normal" 
                    color={colors.primary} 
                  >  
                    {file?.fileType}
                  </Text>
                </StyledTableCell>
                <StyledTableCell align="center" className={classes.statusPadding}>
                  <span className={file?.status === 'ERROR' ? classes.errorBadge : file?.status === 'ACTIVE' ?  classes.successBadge : file?.status === 'IN REVIEW' ? classes.inReview : 
                    file?.status === 'PAUSED' ? classes.paused : file?.status === 'CANCELLED' ? classes.cancelled : ''}>{file?.status === '_' ? '' : updatedReportName(file?.status)}</span>
                </StyledTableCell>
                
                <StyledTableCell align='left'>
                  <div className={file?.status === 'ACTIVE' ? classes.update : classes.noUpdate} onClick={file?.status === 'ACTIVE' ? () => editRow(file) : null}>
                    <UpdateManual />
                    <Text 
                      size='footnote' 
                      weight="normal" 
                      color={colors.primary} 
                    >  
                    Update
                    </Text>
                  </div>
                </StyledTableCell>
              </StyledTableRow>
            ))}
        </TableBody>
      </Table>
      {/* {sortedFiles.length !== 0 && 
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
        labelDisplayedRows={({ page } ) =>  'Page ' + (page+1)}
        backIconButtonProps={btnProps}
        nextIconButtonProps={nextIconButtonProps}
      />
      } */}
      {
        sortedFiles?.length === 0 && !error &&
        <div className="loadingContainer">
          <Text size='footnote' color={colors.grey} className={classes.margin} >No items found</Text>
          <Loading options={EMPTY} height={180} />
        </div>
      }
    </TableContainer>
  )
}